import api from "@/services/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { ListParams } from "../types/common";
import { SaveSchoolFacilityPayload } from "../types/schoolFacilityType";

export const getSchoolFacilityList = createAsyncThunk("/schoolFacility/list", async (params: ListParams = {}) => {
  const query = new URLSearchParams();
  if (params.page) query.set("page", String(params.page));
  if (params.limit) query.set("limit", String(params.limit));
  if (params.keyword) query.set("keyword", params.keyword);
  const response = (await api.get(`/schoolfacility?${query.toString()}`)).data;
  return response;
});

export const getSchoolFacilityDetail = createAsyncThunk("/schoolFacility/detail", async (slug: string) => {
  const response = (await api.get(`/schoolfacility/${slug}`)).data;
  return response;
});

export const saveSchoolFacility = createAsyncThunk("/schoolFacility/save", async (payload: SaveSchoolFacilityPayload) => {
  const response = (await api.post("/schoolfacility/action", payload)).data;
  return response;
});

export const deleteSchoolFacility = createAsyncThunk("/schoolFacility/delete", async (id: number) => {
  const response = (await api.get(`/schoolfacility/delete/${id}`)).data;
  return response;
});
